import { lock, unlock } from 'tua-body-scroll-lock'
import { MODAL_OPEN } from '../utilities/constants'

export default class {
  constructor(el, options) {
    const modalButtons = document.querySelectorAll('.js-modalToggle')

    if (!modalButtons) {
      return
    }

    const modalContainer = el.querySelector('.js-modalScroll')
    const modalMetaEl = el.querySelector('.js-modalMeta')
    const modalTitleEl = el.querySelector('.js-modalTitle')
    const modalTextEl = el.querySelector('.js-modalText')
    const modalImageEl = el.querySelector('.js-modalImage')
    const modalUrlEl = el.querySelector('.js-modalUrl')

    Array.from(modalButtons).forEach((modalButton) => {
      modalButton.addEventListener('click', () => {
        modalMetaEl.textContent = modalButton?.dataset?.meta ?? ''
        modalTitleEl.textContent = modalButton?.dataset?.title ?? ''
        modalTextEl.textContent = modalButton?.dataset?.text ?? ''
        modalImageEl.src = modalButton?.dataset?.imageSrc ?? ''
        modalImageEl.srcset = modalButton?.dataset?.imageSrcset ?? ''
        modalImageEl.alt = modalButton?.dataset?.title ?? ''
        modalUrlEl.value = modalButton?.dataset?.url ?? ''

        window.requestAnimationFrame(() => {
          const toOpen = document.documentElement.classList.toggle(MODAL_OPEN)

          if (toOpen) {
            el.querySelector('input').focus({
              preventScroll: true,
            })
          }
        })
      })
    })

    window.addEventListener('keyup', (e) => {
      if (
        e.key === 'Escape' &&
        document.documentElement.classList.contains(MODAL_OPEN)
      ) {
        document.documentElement.classList.remove(MODAL_OPEN)
      }
    })

    let prevState = document.documentElement.classList.contains(MODAL_OPEN)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const isOpen = mutation.target.classList.contains(MODAL_OPEN)

        if (isOpen === prevState) {
          return
        }

        if (isOpen) {
          lock(modalContainer)
        } else {
          unlock(modalContainer)

          setTimeout(() => {
            modalMetaEl.textContent = ''
            modalTitleEl.textContent = ''
            modalTextEl.textContent = ''
            modalImageEl.src = ''
            modalImageEl.srcset = ''
            modalImageEl.alt = ''
            modalUrlEl.value = ''
          }, 100)
        }

        prevState = isOpen
      })
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }
}
